import { h, Component } from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {connect} from 'react-redux'
import {Container} from 'components/elements'
import { 
    PatientInformation, 
    ContactInformation,
    GenericPatientInformation
} from 'components/partials'
import _ from 'lodash'

@connect((state)=> state)
export default class CollectInformation extends WidgetComponent {
	constructor(){
        super()
        this.state = {
            finishedPatientIDs: [],
            finishedClient: false
        }
        this.handleContactSubmit = this.handleContactSubmit.bind(this)
        this.handlePatientSubmit = this.handlePatientSubmit.bind(this)
        this.patientHasRequired = this.patientHasRequired.bind(this)
        this.patientMissingFields = this.patientMissingFields.bind(this)
        this.showPatientEdit = this.showPatientEdit.bind(this)
	}

	componentDidMount(){
        let finishedPatientIDs = []
        Object.keys(this.props.selectedPatients).forEach((patientID)=>{
            let patient = this.props.patients[patientID]
            if(this.patientHasRequired(patient)){
                finishedPatientIDs.push(patient.id)
            }
        })
        this.setState({
            finishedPatientIDs
        })
        if(this.session.accessToken && finishedPatientIDs.length == this.props.filters.patientCount){
            super.componentDidSubmit()
            return
        }
    }
    
    get selectedPatient(){
        let patients = []   
        Object.keys(this.props.selectedPatients).forEach((id)=>{
            if(this.state.finishedPatientIDs.indexOf(id) == -1){
                patients.push(this.props.patients[id])
            }
        })
        patients.sort((a,b)=>{
            if(/(newPatient|patient)/.test(a.id)){
                return -1
            }
            if(/(newPatient|patient)/.test(b.id)){
                return 1
            }
            return 0
        })
        return patients[0]
    }

    get finishedPatients(){
        let patients = []   
        let reasonHidden = (this.props.config.reason || {}).hide
        if(_.isNil(reasonHidden)) reasonHidden = false
        
        this.state.finishedPatientIDs.forEach((id)=>{
            if(this.props.patients[id] && (reasonHidden || this.props.patients[id].reason)){
                patients.push(this.props.patients[id])
            }
        })
        return patients
    }

    get session(){
        return this.props.session || {}
    }

    get organizationAccess() {
		if(!(this.session.organizations || []).some((organization)=>{ return organization.id == this.props.organization.id})){
			return false
		}
		return true
	}

    patientMissingFields(patient){
        let requiredFields
        if(this.props.config.genericPatients){
            requiredFields = ['firstName','lastName','reason']
        } else {
            requiredFields = ['firstName','birthday','weight','color','reason']
        }
        
        for(let customField of Object.values(this.props.customFields)){
            if(customField.required) requiredFields.push(customField.key)
        }

        let missingFields = []
        for(let requiredField of requiredFields){
            let hidden = (this.props.config[`${requiredField}`] || {}).hide
            if(_.isNil(hidden)) hidden = false

            if(!hidden && _.isNil(patient[requiredField])) {
                missingFields.push(requiredField)
            }
        }
        if(!this.props.config.genericPatients){
            if(_.isNil(patient['genderID']) || !this.props.genders[patient['genderID']]) missingFields.push('genderID')
            if(_.isNil(patient['breedID']) || !this.props.breeds[patient['breedID']]) missingFields.push('breedID')
        }

        return missingFields
    }

    patientHasRequired(patient){
        if(this.patientMissingFields(patient).length > 0){
            return false
        }
        return true
    }

    handlePatientSubmit(values){
        let finishedPatientIDs = this.state.finishedPatientIDs
        if(finishedPatientIDs.indexOf(`${values.id}`) == -1){
            finishedPatientIDs.unshift(values.id)
            this.setState({
                finishedPatientIDs
            })
        }

        if(finishedPatientIDs.length == this.props.filters.patientCount){
           this.componentDidSubmit()
        }
    }

    handleContactSubmit(data){
        this.setState({
            finishedClient: true
        })
    }

    showPatientEdit(patient){
        if(this.patientHasRequired(patient)){
            return false
        }
        let missingFields = this.patientMissingFields(patient)
        if(missingFields.length == 1 && missingFields[0] == 'reason'){
            return false
        }
        return true
    }    

	render() {
		return (
			<div>
                {this.state.finishedClient && (
                    this.props.config.genericPatients ? (
                        <div>
                            {this.selectedPatient && 
                                <GenericPatientInformation 
                                    editing={this.showPatientEdit(this.selectedPatient)}
                                    key={this.selectedPatient.id} 
                                    onSubmit={this.handlePatientSubmit} 
                                    patient={this.selectedPatient} 
                                />
                            }
                            {this.finishedPatients.map((patient)=>(
                                <GenericPatientInformation key={patient.id} onSubmit={this.handlePatientSubmit} patient={patient} />
                            ))}
                        </div>
                    ) : (
                        <Container title='Patients'>
                            {this.selectedPatient && 
                                <PatientInformation 
                                    editing={this.showPatientEdit(this.selectedPatient)}
                                    key={this.selectedPatient.id} 
                                    onSubmit={this.handlePatientSubmit} 
                                    patient={this.selectedPatient} 
                                    type='transparent'
                                    />
                                }
                            {this.finishedPatients.map((patient)=>(
                                <PatientInformation 
                                    key={patient.id} 
                                    onSubmit={this.handlePatientSubmit} 
                                    patient={patient} 
                                    type='transparent'
                                />
                            ))}
                        </Container>
                    )
                )}
                <br />
                {!this.state.finishedClient && (
                    <ContactInformation containerKey="fill-info-contact" finishedClient={this.state.finishedClient} onSubmit={this.handleContactSubmit} />
                )}
            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/templates/CollectInformation/index.js